import React from 'react';
import './ShippingReturn.scss';
import Breadcrumbs from '../../../components/breadcrumbs/Breadcrumbs';

const ShippingReturn = () => {
  return (
    <div className="shipping-returns">
      <Breadcrumbs path={`help/Shipping & Returns`} />
      <div className="wrapper">
        <h1 className="text heading">Not available in this version</h1>
        {/* <div className="content">
          <div className="section">
            <h2 className="text heading black">Delivery</h2>
            <p>Please note that delivery can only be to valid addresses in [country].</p>
            <p>
              The Products will be delivered either to the address specified by you on your order,
              or at our store stated on the receipt of order.
            </p>
            <p>
              We will use our best endeavours to deliver the Products to you within the timeframes
              set out in our confirmation of your order.
            </p>
            <p>
              Any delay in the delivery of Products will not entitle you to terminate the order
              unless the delay exceeds 30 days from the date of our confirmation of the order.
            </p>
            <p>Please note that your order may be shipped to you in several parts.</p>
          </div>
          <div className="section">
            <h2 className="text heading black">Returns Policy</h2>
            <p>
              We will issue a full refund or replacement of goods in all instances where;
              <br />
              1. Prescription lenses and contact lenses are supplied to the wrong specification as
              per your prescription <br />
              2. Products are supplied damaged;
              <br />
              2. Products are supplied damaged;
              <br />
              3. The Products you have ordered are returned to us as undeliverable by the postal
              service.
              <br />
              4. TProduct is returned within the Return Period.
            </p>
            <p>
              In all instances (save returns to us as undeliverable) you should contact our customer
              services to request a return and the relevant return address. A refund or replacement
              will be issued to you following their receipt at that address within 30 days of that
              date. If Products are returned as undeliverable, you will be contacted by email for
              confirmation of the delivery address. If no reply is received within a reasonable
              period and in any event within 30 days of the return of the Products, then a refund
              will be made within 30 days of that date.
            </p>
            <p>
              We shall pay the postal charge for Products returned under this article. You do not
              need to pay anything. We may refuse to accept future orders from those who have made
              previous unsubstantiated claims for non-delivery of Products. Refunds will be limited
              to the maximum value of the original order, including delivery charges and will only
              be issued against the same credit or debit card account as supplied to pay for the
              Products. We reserve the right to proportionately reduce the level of the refund if
              only some of the original quantity of Products is returned, or if it is clear that
              some of the Products have been used. In the case of Products returned under your
              cooling off right, these must be returned undamaged and unused to qualify for a refund
              (no open packages).
            </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};
export default ShippingReturn;
